import { z } from 'zod';
import { fundingTypeValues } from '@/entities/settlementstatisticsconverter/lib/funding-type';
import { recurringTypeValues } from '@/entities/settlementstatisticsconverter/lib/recurring-type';

/**
 * 財源充当（歳出）フォームのバリデーションスキーマ
 * 追加・編集共通で使用
 */
export const revenueAppropriationExpenditureSchema = z.object({
  /** 会計区分コード */
  accounting_type_code: z.string().min(1),
  /** 歳出科目（款項目）コードパス */
  expenditure_category_code_path: z.array(z.string()).min(1),
  /** 事業階層コードパス（任意） */
  project_category_code_path: z.array(z.string()).optional(),
  /** 事業コード */
  project_code: z.string().min(1),
  /** 決算統計目的コードパス */
  settlement_purpose_code_path: z.array(z.string()).min(1),
  /** 決算統計性質コードパス */
  settlement_nature_code_path: z.array(z.string()).min(1),
  /** 臨時経常区分 */
  recurring_type: z.enum(recurringTypeValues),
  /** 単独補助区分 */
  funding_type: z.enum(fundingTypeValues),
  /** 財源充当金額 */
  revenue_appropriation_amount: z.number().int(),
});

export type RevenueAppropriationExpenditureFormValues = z.infer<
  typeof revenueAppropriationExpenditureSchema
>;
